import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class Folder extends DomainObject {
  @observable name;
  @observable createdAt;
  @observable updatedAt;
  @observable hasDocuments;
  @observable companyDocuments;
}

export default Folder;
